<template>
    <v-select
        :id="id"
        ref="field"
        v-bind="$attrs"
        :class="{ 'is-invalid': invalid }"
        :clearable="clearable"
        :error="invalid"
        :error-messages="errorMessages"
        :item-disabled="option => option.disabled"
        :item-text="getName"
        :item-value="getValue"
        :items="computedOptions"
        outlined
        :placeholder="computedPlaceholder"
        :value="selectedItem"
        :disabled="disabled"
        @input="update"
        @focus="onfocus"
        @blur="onblur"
    >
        <template #option="option">
            <slot name="option" v-bind="option"></slot>
        </template>

        <template #label :label="label">
            <slot name="label">{{ $attrs.label }}</slot> <sup :class="{ invisible: !required }">*</sup>
        </template>

        <template #list-footer>
            <slot name="list-footer"></slot>
        </template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </v-select>
</template>

<script>
    import FieldMixin from "@/components/form/FieldMixin.vue"
    import FieldWithOptionsMixin from "@/components/form/FieldWithOptionsMixin"

    export default {
        mixins: [FieldMixin, FieldWithOptionsMixin],
        inheritAttrs: false,

        props: {
            showDefault: {
                type: [Boolean, String],
                default: true,
            },
            defaultName: {
                type: String,
                required: false,
            },
            placeholder: {
                type: String,
            },
        },

        data() {
            return {}
        },

        computed: {
            computedPlaceholder() {
                if (this.placeholder) {
                    return this.placeholder
                }

                if (!this.showDefaultOption || !this.defaultDisabled) {
                    return ""
                }

                return this.defaultOptionName
            },

            showDefaultOption() {
                return this.showDefault === "true" || this.showDefault === true
            },

            defaultDisabled() {
                return this.required
            },

            defaultOptionName() {
                if (this.defaultName) {
                    return this.defaultName
                }

                if (this.required) {
                    return "Select One"
                }

                return "None"
            },

            clearable() {
                return this.value != null && this.showDefaultOption
            },

            selectedItem() {
                const valueGetter = this.valueGetter
                return this.computedOptions.find(opt => this.value === valueGetter(opt))
            },
        },

        mounted() {
            // prevent clear icon from being tabbable
            this.removeTabIndex()
        },

        methods: {
            customizeOptions(options) {
                if (this.showDefaultOption && !this.defaultDisabled) {
                    const defaultOption = { name: this.defaultOptionName, value: null }
                    defaultOption[this.$defaultProp] = true
                    options.unshift(defaultOption)
                }

                return options
            },

            onfocus(event) {
                if (this.vcform) this.vcform.emitFieldEvent("focus", this, event)
            },

            onblur(event) {
                if (this.vcform) this.vcform.emitFieldEvent("blur", this, event)
            },

            removeTabIndex() {
                let element = this.$refs.field.$el.querySelector(".v-icon")
                if (element) element.setAttribute("tabindex", "-1")
            },

            update(value) {
                this.$emit("input", value)

                setTimeout(() => {
                    this.removeTabIndex()
                })

                let selectedOption = this.options.find(option => {
                    return value === this.valueGetter(option)
                })

                if (selectedOption) {
                    this.$emit("select", selectedOption)
                }

                //
                // // need to wait until next tick because validation was happening before the field's model value actually updated
                setTimeout(() => {
                    this.$emit("validate")
                })
            },
        },
    }
</script>
